"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
var react_1 = require("react");
/**
 * @returns ref to pass to the target element, ElementDimensions
 */
var useResizeObserver = function () {
    var _a = (0, react_1.useState)({}), dimensions = _a[0], setDimensions = _a[1];
    var observer = (0, react_1.useRef)(null); // we only need one observer instance
    var element = (0, react_1.useRef)(null);
    var handleResize = (0, react_1.useCallback)(function (entries) {
        if (!Array.isArray(entries)) {
            return;
        }
        var entry = entries[0];
        var newDimensions = {
            contentWidth: entry.contentRect.width,
            contentHeight: entry.contentRect.height,
            clientWidth: entry.target.clientWidth,
            clientHeight: entry.target.clientHeight,
            scrollWidth: entry.target.scrollWidth,
            scrollHeight: entry.target.scrollHeight,
            isOverflowingX: entry.target.clientWidth < entry.target.scrollWidth,
            isOverflowingY: entry.target.clientHeight < entry.target.scrollHeight,
            // compute once on access then replace the getter with result
            get isOverflowing() {
                delete this.isOverflowing;
                this.isOverflowing = this.isOverflowingX || this.isOverflowingY;
                return this.isOverflowing;
            },
        };
        setDimensions(newDimensions);
    }, []);
    // initialize resize observer
    var observeRef = (0, react_1.useCallback)(function (target) {
        var _a;
        // the callback ref fires often without a target, so only process when we have a target
        if (!target) {
            return;
        }
        // instantiate a new observer if needed
        if (!observer.current) {
            observer.current = new ResizeObserver(function (entries) { return handleResize(entries); });
        }
        // monitor the new element with cleanup of the old element
        if (element.current !== target) {
            element.current && ((_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect()); // call disconnect if monitoring old element
            observer.current.observe(target);
            element.current = target;
        }
    }, [handleResize]);
    return { observeRef: observeRef, dimensions: dimensions };
};
exports.useResizeObserver = useResizeObserver;
